import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import { TopologyVersion, useDeleteTopologyVersionMutation } from '../../../../../app/apiSlice';
import { setToast } from '../../../../../app/appSlice';
import { useSecureApplication } from '../../../../../hooks/KeycloackConnection';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IDeleteVersion {
    version: TopologyVersion;
    onDone: () => any;
}

const DeleteVersion = ({version, onDone}: IDeleteVersion) => {

    const { hasAnyPerm } = useSecureApplication();
    const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);
    const [deleteVersion, deleteVersionStatus] = useDeleteTopologyVersionMutation();
    const dispatch = useDispatch();
    const {t: translate} = useTranslation();

    const footerDialog = () => {
        return (
            <>
                <Button
                    label={translate('button.cancel')}
                    onClick={() => setDialogVisibility(false)}
                    className="mr-3 p-button-outlined p-button-sm"
                />

                <Button
                    id="hook-form"
                    onClick={async () => {
                        try {
                            await deleteVersion({id: version.id, version: version.version}).unwrap();
                            dispatch(
                                setToast({
                                    title: translate('versions.delete'),
                                    severity: 'success',
                                    content: translate('versions.delete_done'),
                                    life: 3000,
                                })
                            );
                            setDialogVisibility(false);
                            onDone();
                        } catch (e: any) {
                            dispatch(
                                setToast({
                                    title: translate('versions.delete'),
                                    severity: 'error',
                                    content: translate('versions.delete_fail'),
                                    life: 3000,
                                })
                            );
                        }
                    }}
                    type="submit"
                    label={translate('button.delete')}
                    className="p-button-danger p-button-sm"
                >
                    {deleteVersionStatus.isLoading ? (
                        <FontAwesomeIcon className="ml-2" icon="spinner" spin/>
                    ) : null}
                </Button>
            </>
        );
    };

    return (
        <>
            <Dialog
                header={translate('versions.delete')}
                footer={footerDialog}
                visible={dialogVisibility}
                style={{width: '25vw'}}
                modal
                onHide={() => {
                    setDialogVisibility(false);
                }}
            >
                <div className="mb-3">
                    {translate('versions.delete_confirm')} {' '}
                    <span className="font-bold">{version.version}</span> ?
                </div>
            </Dialog>
            <Button
                className="p-button-text"
                icon="pi pi-trash"
                title={translate('button.delete')}
                disabled={!hasAnyPerm('pipelines.all', 'pipelines_del')}
                onClick={() => {
                    setDialogVisibility(true);
                }}
            ></Button>
        </>
    );
};

export default DeleteVersion;
